import { Facebook, Instagram } from '@shared/icons';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { FooterCopyrightAndSocialsSectionConfig, FooterSocialIconKey } from '../../../../config/footer.types.ts';

type CopyrightAndSocialsSectionProps = {
  config: FooterCopyrightAndSocialsSectionConfig;
};

function renderSocialIcon(iconKey: FooterSocialIconKey) {
  switch (iconKey) {
    case 'Instagram':
      return <Instagram size="large" />;
    case 'Facebook':
      return <Facebook size="large" />;
    default:
      return null;
  }
}

function CopyrightAndSocialsSection({ config }: CopyrightAndSocialsSectionProps) {
  const t = useTranslations('footer.copyright_and_socials');
  const { copyrightTranslationKey, socialLinks } = config;

  return (
    <div className="flex flex-row justify-between items-center">
      {copyrightTranslationKey ? <p className="paragraph-s">&copy; {t(copyrightTranslationKey)}</p> : null}

      {socialLinks?.length ? (
        <div className="flex flex-row gap-2" data-track-container="Socials">
          {socialLinks.map(social => (
            <Link key={social.label} href={social.href} aria-label={social.label} data-track-name={social.trackName} className="w-8 h-8">
              {renderSocialIcon(social.iconKey)}
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export { CopyrightAndSocialsSection };
